import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

interface TutoStep {
  icon: string;
  title: string;
  description: string;
  items: string[];
}

@Component({
  selector: 'app-welcome-modal',
  templateUrl: './welcome-modal.component.html',
  styleUrls: ['./welcome-modal.component.scss'],
  imports: [CommonModule, RouterLink],
})
export class WelcomeModalComponent {
  @Input() userName = '';

  currentStep = 0;

  steps: TutoStep[] = [
    {
      icon: '🏨',
      title: 'Bienvenue sur Hotelgex',
      description: "Votre plateforme complète de gestion hôtelière en ligne. Gérez votre hôtel, vos réservations et vos opérations quotidiennes depuis n'importe où.",
      items: [
        'Accessible depuis tout navigateur web',
        'Interface intuitive et responsive',
        'Données sécurisées en temps réel',
        'Notifications instantanées',
      ],
    },
    {
      icon: '📊',
      title: 'Tableau de bord',
      description: "Votre vue d'ensemble de l'activité. Suivez en temps réel tous les indicateurs clés de votre hôtel.",
      items: [
        'Réservations du jour et à venir',
        'Hébergements en cours',
        'Chiffre d\'affaires quotidien',
        'Commandes restaurant et boutique',
        'Chambres disponibles / occupées',
      ],
    },
    {
      icon: '⚙️',
      title: "Paramètres de l'hôtel",
      description: 'Configurez votre hôtel avant de démarrer. Ces paramètres sont essentiels au bon fonctionnement de la plateforme.',
      items: [
        'Informations générales (nom, contacts, localisation)',
        'Types et tarifs de chambres',
        'Services et périodicités',
        'Employés et rôles',
        'Espaces et types de menus',
      ],
    },
    {
      icon: '📋',
      title: 'Gestion des opérations',
      description: 'Toutes vos opérations quotidiennes centralisées. Créez, modifiez et suivez chaque transaction.',
      items: [
        'Réservations : pré-réserver une chambre',
        'Hébergements : gérer les séjours en cours',
        'Commandes : restaurant et boutique',
        'Livraisons et règlements',
        'Demandes de remise et ristournes',
      ],
    },
    {
      icon: '💰',
      title: 'Trésorerie & Rapports',
      description: 'Pilotez vos finances et analysez vos performances grâce aux outils de reporting intégrés.',
      items: [
        'Suivi des caisses et mouvements',
        'Rapports de ventes et recettes',
        'État des règlements',
        'Gestion de la fidélité client',
        'Export des données (Excel)',
      ],
    },
  ];

  get isFirst(): boolean { return this.currentStep === 0; }
  get isLast(): boolean { return this.currentStep === this.steps.length - 1; }
  get current(): TutoStep { return this.steps[this.currentStep]; }
  get progress(): number { return ((this.currentStep + 1) / this.steps.length) * 100; }

  constructor(public activeModal: NgbActiveModal) {}

  next(): void { if (!this.isLast) this.currentStep++; }
  prev(): void { if (!this.isFirst) this.currentStep--; }
  goTo(i: number): void { this.currentStep = i; }
  close(): void {
    localStorage.setItem('hgx_guide_seen', '1');
    this.activeModal.close();
  }
}
